import { usePostMaterialApi, usePutMaterialApi } from 'api/material'
import { Flex } from 'components/shared/flex'
import { CheckboxField, ChoiceField, InputField } from 'components/shared/input'
import { GlobalStateContext } from 'contexts/global_state_context'
import { useContext, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { Form, useEffectSkipFirst, useForm } from 'utils/hooks'
import { ApiError } from 'utils/network/api_hooks'
import { Material, MaterialForm } from 'entities/material'

export type FormViewProps = {
    form: Form<MaterialForm>
    apiError: ApiError
}

const FormView = ({ form, apiError }: FormViewProps) => {
    return (
        <>
            <InputField form={form} attr="name" apiError={apiError} label="名称" required />
            <Flex>
                <ChoiceField form={form} attr="category" apiError={apiError} label="カテゴリ" tableName="material" />
                <ChoiceField form={form} attr="kind" apiError={apiError} label="種類" tableName="material" />
            </Flex>
            <Flex>
                <ChoiceField form={form} attr="lead" apiError={apiError} label="リード" tableName="material" />
                <ChoiceField form={form} attr="shippedBy" apiError={apiError} label="出荷担当" tableName="material" />
            </Flex>
            <CheckboxField form={form} attr="disabled" apiError={apiError} checkboxLabel="非表示にする" />
        </>
    )
}

type NewMaterialFormProps = {
    onComplete?: () => void
}

export const NewMaterialForm = (props: NewMaterialFormProps): JSX.Element => {
    const globalState = useContext(GlobalStateContext)
    const api = usePostMaterialApi()
    const form = useForm<MaterialForm>({})
    const [show, setShow] = useState<boolean>(false)

    const handleUpdate = () => {
        api.execute(form)
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
        if (api.isSuccess()) {
            if (props.onComplete) {
                setShow(false)
                props.onComplete()
            }
        }
    }, [api.loading])

    const handleClose = () => {
        setShow(false)
    }

    return (
        <>
            <Button
                variant="success"
                onClick={() => {
                    setShow(true)
                }}
            >
                新規登録
            </Button>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>資材の登録</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <>
                        <FormView form={form} apiError={api.apiError} />
                    </>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        閉じる
                    </Button>
                    <Button variant="success" onClick={handleUpdate}>
                        登録
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
type EditMaterialFormProps = {
    material: Material
    show: boolean
    onClose: () => void
    onComplete?: () => void
}

export const EditMaterialForm = (props: EditMaterialFormProps): JSX.Element => {
    const globalState = useContext(GlobalStateContext)
    const api = usePutMaterialApi()
    const form = useForm<MaterialForm>(props.material)

    useEffectSkipFirst(() => {
        form.set(props.material)
    }, [props.material])

    const handleUpdate = () => {
        api.execute(form)
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
        if (api.isSuccess()) {
            if (props.onComplete) {
                props.onComplete()
            }
        }
    }, [api.loading])

    return (
        <Modal show={props.show} onHide={props.onClose}>
            <Modal.Header closeButton>
                <Modal.Title>資材の編集</Modal.Title>
            </Modal.Header>
            <Modal.Body>{form.object.id && <FormView form={form} apiError={api.apiError} />}</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onClose}>
                    閉じる
                </Button>
                <Button variant="success" onClick={handleUpdate}>
                    更新
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
